import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/utilTypes';

export const checkHash = (): Action<void> => updateAction(actionTypes.CHECK_HASH);
export const newVersionAvilable = (payload: any): Action<void> => updateAction(actionTypes.NEW_VERSION_AVILABLE, payload);
export const updatePreviousLocation = (payload: any): Action<any> => updateAction(actionTypes.UPDATE_OLD_LOCATION, payload);
export const triggerJitsiEmail = (payload: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.TRIGGER_JITSI_EMAIL, {payload, onSuccess, onError});

export const saveNotifications = (payload: any, isAppend?: boolean, isFromWS?: boolean): Action<any[]> => ({
  type: actionTypes.SAVE_NOTIFICATIONS, ...{ payload, isAppend, isFromWS},
});

export const refreshInternalData = (
  refreshLogin: boolean = false,
  refreshLookUp: boolean = false,
  refreshPayerLookUp: boolean = false,
  masterDataCurrVersion: any = null,
  isSuperLogin: boolean | (() => boolean) = false,
): Action<any> => {
  const isSuperLoginValue = typeof isSuperLogin === 'function' ? isSuperLogin() : isSuperLogin;
  return updateAction(actionTypes.REFRESH_INTERNAL_DATA, {
    refreshLogin,
    refreshLookUp,
    refreshPayerLookUp,
    masterDataCurrVersion,
    isSuperLogin: isSuperLoginValue,
  });
};

export const fetchNotifications = (payload: any): Action<any> => updateAction(actionTypes.FETCH_NOTIFICATIONS, payload);
export const enableDisableNotifications = (isNotificationEnabled: boolean, onSuccessIsEnabled: any, onFailureIsEnabled: any): Action<any> =>
  updateAction(actionTypes.ENABLE_DISABLE_NOTIFICATIONS, { isNotificationEnabled, onSuccessIsEnabled, onFailureIsEnabled });
export const subscribeNotifications = (payload: any): Action<any> => updateAction(actionTypes.SUBSCRIBE_NOTIFICATIONS, payload);
export const unsubscribeNotifications = (payload: any): Action<any> => updateAction(actionTypes.UNSUBSCRIBE_NOTIFICATIONS, payload);
export const readNotifications = (messageIds: number[], onSuccessRead: any, onFailureRead: any, isMarkAllAsRead: boolean): Action<any> =>
  updateAction(actionTypes.READ_NOTIFICATIONS, { messageIds, onSuccessRead, onFailureRead, isMarkAllAsRead });
export const updateIsReadNotification = (messageId: number): Action<any> =>
  updateAction(actionTypes.UPDATE_IS_READ_NOTIFICATION, messageId);
export const updateUnreadAndTotalCount = (totalNotificationUnReadCount: any, totalNotificationCount?: any): Action<any> =>
  updateAction(actionTypes.UPDATE_UNREAD_AND_TOTAL_COUNT, { totalNotificationUnReadCount, totalNotificationCount });
export const updateIsOnNotificationflow = (payload: any): Action<any> => updateAction(actionTypes.IS_ON_NOTIFICATION_FLOW, payload);
